import { render, staticRenderFns } from "./StateBorders.vue?vue&type=template&id=50a2d69e&"
import script from "./StateBorders.vue?vue&type=script&lang=ts&"
export * from "./StateBorders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports